import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogInfo.css";

export default function BlogInfo({ blog }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // 👈 vuelve a la página anterior
  };

  return (
    <section className="blog-detail-container">
      {/* --- BOTÓN VOLVER --- */}
      <button className="back-button" onClick={handleBack}>
        ← Volver
      </button>

      {/* --- TITULOS --- */}
      <h1 className="blog-main-title">{blog.title}</h1>
      <h2 className="blog-subtitle">{blog.subtitle}</h2>

      {/* --- IMAGEN PRINCIPAL --- */}
      <div className="blog-detail-image">
        <img src={blog.imageDetail} alt={blog.title} />
      </div>

      {/* --- SUBTÍTULO INTERNO --- */}
      <h3 className="blog-inner-title">
        {blog.title}: {blog.subtitle}
      </h3>

      {/* --- CONTENIDO PRINCIPAL --- */}
      <article
        className="blog-detail-content"
        dangerouslySetInnerHTML={{ __html: blog.fullText }}
      ></article>

      {/* --- AUTOR --- */}
      <div className="blog-author-card">
        <img
          src={blog.authorImage}
          alt={blog.author}
          className="blog-author-img"
        />
        <div className="blog-author-info">
          <h4>{blog.author}</h4>
          <p>{blog.position}</p>
        </div>
      </div>
    </section>
  );
}
